import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../Icon';
import T from '../components/EditableText';
import usePageMeta from '../usePageMeta';
import { useKampagnenTelefon } from './M38Layout';
import { track, M38_EVENTS } from './tracking';

/**
 * Danke-Seite nach dem Betreuungs-Check.
 *
 * Eine eigene Adresse und keine Meldung im Formular — das war eine ausdrückliche
 * Anforderung des Konzepts: Nur so lässt sich in der Statistik zählen, wie viele
 * Anfragen tatsächlich abgeschickt wurden, statt nur wie viele Formulare
 * geöffnet waren.
 *
 * `noindex`, weil sie als Sucheinstieg sinnlos wäre: Wer über Google hier
 * ankäme, hätte nie ein Formular ausgefüllt und läse eine Bestätigung für etwas,
 * das er nie getan hat.
 */
const Danke: React.FC = () => {
  const telefon = useKampagnenTelefon();

  usePageMeta(
    'Vielen Dank für Ihre Anfrage',
    'Ihre Anfrage ist bei uns eingegangen. Wir melden uns persönlich bei Ihnen.',
    { noindex: true },
  );

  return (
    <section className="section section--tinted thanks">
      <div className="shell shell--prose centered">
        <div className="thanks-icon" aria-hidden="true">
          <Icon name="check" size={32} />
        </div>
        <h1 className="h-page">
          <T k="m38.danke.titel" />
        </h1>
        <p className="lead" style={{ marginBottom: 26 }}>
          <T k="m38.danke.text" />
        </p>
        <div className="btn-row" style={{ justifyContent: 'center' }}>
          <a
            className="btn btn--primary"
            href={telefon.href}
            onClick={() => track(M38_EVENTS.telefon, { stelle: 'danke' })}
          >
            <Icon name="phone" size={18} /> {telefon.label}
          </a>
          <Link className="btn btn--ghost" to="/">
            <T k="m38.danke.zurueck" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Danke;
